// extracted by mini-css-extract-plugin
export default {"row":"RateAndShare_row__N6IQs","ratingCol":"RateAndShare_ratingCol__2z5QN"};